__webpack_require__.p = "/Quiz_for_son/";